import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=6da8e133&scoped=true"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"
import style0 from "./resource.vue?vue&type=style&index=0&id=6da8e133&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8e133",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da8e133')) {
      api.createRecord('6da8e133', component.options)
    } else {
      api.reload('6da8e133', component.options)
    }
    module.hot.accept("./resource.vue?vue&type=template&id=6da8e133&scoped=true", function () {
      api.rerender('6da8e133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systems/resource.vue"
export default component.exports